import React, { useState } from 'react';
import { Link } from 'gatsby';
import PropTypes from 'prop-types';
import ArrowDown from '../../../images/icons/arrow-down-menu.svg';

function MenuText({ title, urlLink,textColor, withDropDown, linkClassName, imgClassName, isNew, id }) {
  const [navLine, setNavLine] = useState(false);

  return (
    <div >
      {urlLink ? (
        <Link
          to={urlLink}
          className={`menu-text text-sm ${textColor} ${linkClassName}`}
          id={id}
        >
          {title}
        </Link>
      ) : (
        <div
          className={`menu-text cursor-pointer text-lg ${navLine ? 'active' : null} ${linkClassName}`}
          onMouseEnter={() => setNavLine(true)}
          onMouseLeave={() => setNavLine(false)}
        >
          {title}

          {withDropDown ? <img src={ArrowDown} className={imgClassName} alt="arrow down" /> : ''}
        </div>
      )}
    </div>
  );
}

export default MenuText;

MenuText.propTypes = {
  title: PropTypes.string,
  urlLink: PropTypes.string,
  withDropDown: PropTypes.bool,
  imgClassName: PropTypes.bool,
  linkClassName: PropTypes.bool,
  isNew: PropTypes.bool,
  id: PropTypes.string
};

MenuText.defaultProps = {
  withDropDown: false
};
